export default __webpack_public_path__ + "static/media/img_filterNoData.63e30470.svg";